import { ITranslation } from '../interfaces/translation';

export const getTranslation = (
  translations: readonly ITranslation[] | undefined,
  language: string,
  defaultValue?: string
) => {
  if (!translations) return defaultValue || '';

  const translation = translations.find(tl => tl.language === language);

  return translation?.description || translation?.name || defaultValue || '';
};
